import { SORTING_FIELDS } from '../common/constants/constants';
import { AvailableTypeEnum, FieldTypesType } from './attributes.types';

export const OTHER_ATTRIBUTES_KEY = 'Other Attributes';

export const SORTING_FIELDS_FOR_ATTRIBUTES = {
    sequenceAsc: SORTING_FIELDS.sequenceAsc,
    sequenceDesc: SORTING_FIELDS.sequenceDesc,
    updatedOnDesc: SORTING_FIELDS.updatedOnDesc
};

export const CUSTOM_FIELD_IMPORT_MAP = {
    sender: 'sendersString',
    submittedTo: 'submittedToString',
    writers: 'writersString',
    readers: 'readersString'
} as const;

export const SUBMISSION_DROPDOWN_FIELDS = {
    sender: true,
    submittedTo: true,
    writers: true,
    readers: true
} as const;

export const fieldTypes: FieldTypesType = {
    [AvailableTypeEnum.number]: {
        typeName: 'Number',
        fieldType: AvailableTypeEnum.number,
        description: 'Number field description goes here'
    },
    [AvailableTypeEnum.text]: {
        typeName: 'Text',
        fieldType: AvailableTypeEnum.text,
        description: 'Text field description goes here'
    },
    [AvailableTypeEnum.termset]: {
        typeName: 'Termset',
        fieldType: AvailableTypeEnum.termset,
        description: 'Termset field description goes here'
    },
    [AvailableTypeEnum.time]: {
        typeName: 'Time',
        fieldType: AvailableTypeEnum.time,
        description: 'Time field description goes here'
    },
    [AvailableTypeEnum.date]: {
        typeName: 'Date',
        fieldType: AvailableTypeEnum.date,
        description: 'Date field description goes here'
    },
    [AvailableTypeEnum.boolean]: {
        typeName: 'Boolean',
        fieldType: AvailableTypeEnum.boolean,
        description: 'Boolean field description goes here'
    },
    [AvailableTypeEnum.decimal]: {
        typeName: 'Decimal',
        fieldType: AvailableTypeEnum.decimal,
        description: 'Decimal field description goes here'
    },
    [AvailableTypeEnum.measurement]: {
        typeName: 'Measurement',
        fieldType: AvailableTypeEnum.measurement,
        description: 'Measurement field description goes here'
    },
    [AvailableTypeEnum.note]: {
        typeName: 'Note',
        fieldType: AvailableTypeEnum.note,
        description: 'Note field description goes here'
    },
    [AvailableTypeEnum.calculationType]: {
        typeName: 'Calculation Type',
        fieldType: AvailableTypeEnum.calculationType,
        description: 'Calculation Type field description goes here'
    },
    [AvailableTypeEnum.reference]: {
        typeName: 'Reference',
        fieldType: AvailableTypeEnum.reference,
        description: 'Reference field description goes here'
    },
    [AvailableTypeEnum.location]: {
        typeName: 'Location',
        fieldType: AvailableTypeEnum.location,
        description: 'Location field description goes here'
    }
};
